import { render } from "./AudioGuide.vue?vue&type=template&id=20cd9761&scoped=true"
import script from "./AudioGuide.vue?vue&type=script&lang=js"
export * from "./AudioGuide.vue?vue&type=script&lang=js"

import "./AudioGuide.vue?vue&type=style&index=0&id=20cd9761&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20cd9761"]])

export default __exports__